export default __webpack_public_path__ + "static/media/groom-small.2b099974.png";